import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { StateSchema } from '@/hooks/form/models'

import NumberFormatCustom from '@/views/components/input-number-format/index.component'
import { MAX_FREE_SPIN_QUANTITY, MIN_FREE_SPIN_QUANTITY } from '@/constants'

type Props = {
  handleOnChange: (name: string, value: any) => void
  state: StateSchema
}

const FreeSpinsComponent = ({ handleOnChange, state }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography sx={{ marginBottom: '20px' }}>
        {t('bonusStepFreeSpins')}
      </Typography>
      <Typography fontWeight={700} sx={{ mb: '18px' }}>
        {t('freeSpinQuantityDescription', {
          min: MIN_FREE_SPIN_QUANTITY,
          max: MAX_FREE_SPIN_QUANTITY,
        })}
      </Typography>
      <Box mb={1} maxWidth={400}>
        <NumberFormatCustom
          name="freeSpinQuantity"
          label={t('labels.freeSpinQuantity')}
          handleOnChange={handleOnChange}
          state={state}
          disableInputPropsAdornment
          prefix=""
          fullwidth
        />
      </Box>
    </>
  )
}

export default FreeSpinsComponent
